import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const LINE_ITEM_PRICES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('LINE_ITEM_PRICES');
export const LINE_ITEM_PRICES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	LINE_ITEM_PRICES_CRUD_ACTION_CONSTANTS
);
